import { Box, Container, Grid } from '@mui/material';
import RotatingCard from '../RotatingCard';
import RotatingCardFront from '../RotatingCard/RotatingCardFront';
import RotatingCardBack from '../RotatingCard/RotatingCardBack';
import {
    ContentCopy,
    CopyAll,
    Phonelink,
    PriceChange,
    TouchApp,
} from '@mui/icons-material';

import bgViolet from '../../images/bg-violet.jpg';
import bgVisage from '../../images/header.jpg';
import InfoCard from '../InfoCard';

const InfoSection = () => {
    return (
        <Box component='section' py={6} my={6}>
            <Container>
                <Grid
                    container
                    item
                    xs={11}
                    spacing={3}
                    alignItems='center'
                    sx={{ mx: 'auto' }}
                >
                    <Grid item xs={12} lg={4} sx={{ mx: 'auto' }}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgViolet}
                                icon={<TouchApp fontSize='large' />}
                                title={
                                    <>
                                        Do anim laboris
                                        <br />
                                        aute proident
                                    </>
                                }
                                description='Eu aliquip qui cillum ut dolor reprehenderit exercitation.'
                            />
                            <RotatingCardBack
                                image={bgVisage}
                                bgPosition={'bottom'}
                                title='Ex consectetur ad'
                                description='Aliqua dolore non sit mollit elit in sunt.'
                            />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={7} sx={{ ml: 'auto' }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <InfoCard
                                    icon={<ContentCopy color={'primary'} />}
                                    title={'Full Documentation'}
                                    description={`Built by developers for developers. Check the foundation and you will find
                                                everything inside our documentation.`}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoCard
                                    icon={<CopyAll color={'primary'} />}
                                    title={'MUI Ready'}
                                    description={`The world's most popular react components library for building user interfaces.`}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            spacing={3}
                            sx={{ mt: { xs: 0, md: 6 } }}
                        >
                            <Grid item xs={12} md={6}>
                                <InfoCard
                                    icon={<PriceChange color={'primary'} />}
                                    title={'Save Time & Money'}
                                    description={`TCreating your design from scratch with dedicated designers can be very expensive. Start with our Design System.`}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoCard
                                    icon={<Phonelink color={'primary'} />}
                                    title={'Fully Responsive'}
                                    description={`Regardless of the screen size, the website content will naturally fit the given resolution.`}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default InfoSection;
